import { Image as ImageIcon, Undo2 } from 'lucide-react';

import { PhotoRemoveButtons, type PhotoRemoveButtonsProps } from './PhotoRemoveButtons';

/** Asks before the uploaded photo is removed, and says what customers will see afterwards. */
export function PhotoRemoveConfirm(props: PhotoRemoveButtonsProps) {
  const { hasImportedPhoto } = props;
  return (
    <div
      role="group"
      aria-label="Confirm removing the photo"
      style={{
        borderRadius: 10,
        padding: 12,
        background: 'var(--nb-surface)',
        border: '1px solid var(--nb-border-2)',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
      }}
    >
      <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
        <span
          aria-hidden="true"
          style={{
            width: 64,
            aspectRatio: '16 / 9',
            borderRadius: 6,
            flex: '0 0 auto',
            border: '1.5px dashed var(--nb-border-2)',
            color: 'var(--nb-faint)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {hasImportedPhoto ? <Undo2 size={16} /> : <ImageIcon size={16} />}
        </span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 12.5, fontWeight: 700, color: 'var(--nb-ink)' }}>
            {hasImportedPhoto ? 'Revert to the FareHarbor photo?' : 'Remove the uploaded photo?'}
          </div>
          <div style={{ fontSize: 11.5, color: 'var(--nb-muted)', marginTop: 2, lineHeight: 1.45 }}>
            {hasImportedPhoto
              ? 'Your uploaded photo is removed and customers see the imported FareHarbor photo again.'
              : "There's no imported photo to fall back to, so customers will see a placeholder."}
          </div>
        </div>
      </div>
      <PhotoRemoveButtons {...props} />
    </div>
  );
}
